import { ReactNode } from 'react';
import useScrollDirection from 'shared/hooks/useScrollDirection';
import { CookieState } from 'shared/interface';
import { elementVisibility } from 'shared/util/utility';
import './styles.scss';

interface CouponOverviewPanelProps {
	numOfSlipsInBetslip: number;
	cookie?: CookieState;
	onClick?: () => void;
	children: ReactNode;
	type: 'primary' | 'secondary';
}

const CouponOverviewPanel = ({ numOfSlipsInBetslip, cookie, onClick, children, type }: CouponOverviewPanelProps) => {
	const { scrollDir, scrolledToBottom } = useScrollDirection(0);
	const isElementVisible = elementVisibility(scrolledToBottom, scrollDir, 'CouponOverviewPanel');
	const dynamicClassNames = () => {
		const hasSlips = numOfSlipsInBetslip && numOfSlipsInBetslip > 0;

		if (!hasSlips) {
			return `${isElementVisible} CouponOverviewPanel--fade-out-bottom`;
		}

		if (hasSlips && isElementVisible === 'CouponOverviewPanel--hidden') {
			return `CouponOverviewPanel--initial--visible ${isElementVisible}`;
		}

		return isElementVisible;
	};

	const className = `CouponOverviewPanel ${dynamicClassNames()} ${cookie && cookie.notShowCookie ? '' : 'has-cookies'}`;

	if (numOfSlipsInBetslip === 0) {
		return <div className={className} />;
	}

	return (
		<div className={className + ` CouponOverviewPanel--${type}`} onClick={() => onClick && onClick()}>
			{children}
		</div>
	);
};

export default CouponOverviewPanel;
